import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { softwareCapacityClassicCustomEmbedRoute } from '@atlassian/jira-router-routes-classic-projects-routes/src/softwareCapacityClassicCustomEmbedRoute.tsx';
import { CapacityEmbedSkeleton } from '@atlassian/jira-skeletons/src/ui/capacity/CapacitySkeleton.tsx';
import { chromelessLayout } from '@atlassian/jira-chromeless-layout/src/index.tsx';
import { jiraSpaResources } from '@atlassian/jira-router-resources-spa-page-container/src/index.tsx';
import { softwareCapacityRouteEntry } from './ui/software/capacity/index.tsx';

export const softwareCapacityClassicCustomEmbedRouteEntry = createEntry(
	softwareCapacityClassicCustomEmbedRoute,
	() => ({
		bifrost: {
			bifrostGroup: 'shell-only',
			bundling: {
				packageName:
					'@atlassian/jira-router-routes-classic-projects-entries/src/softwareCapacityClassicCustomEmbedRouteEntry.tsx',
				whichExportToUse: 'softwareCapacityClassicCustomEmbedRouteEntry',
			},
			enabled: true,
		},
		component: CapacityEmbedSkeleton,
		entryPoint() {
			if (__SERVER__) {
				return undefined;
			}
			return softwareCapacityRouteEntry;
		},
		group: 'classic-software',
		layout: chromelessLayout,
		resources: [...jiraSpaResources()],
		skeleton: CapacityEmbedSkeleton,
		ufoName: 'classic-capacity-embed',
	}),
);
